
























































































































import { Component, Vue } from "vue-property-decorator";
import { apiClient } from '@/api/ApiClient';
import moment from 'moment';
import Enumerable from 'linq';
import jwtDecode from 'jwt-decode';

import ECharts from 'vue-echarts';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/legendScroll';

import 'echarts/lib/chart/line';

interface DashboardMonthly {
  country: string;
  monthName: string;
  count: number;
  year: number;
  month: number;
  week: number;
}

@Component({
  components: {
    'v-chart': ECharts
  }
})
export default class Dashboard extends Vue {

  public get moment() {
    return moment;
  }

  public dateRange: Date[] = [moment.utc().local().startOf('month').toDate(), new Date()];

  // filter
  public customers: any[] = [];
  public customerId: number = null;

  // dashboard
  public isDashboardLoading = true;

  public dashboardSummary: any = null;
  public dashboards: any[] = [];

  public regions: any[] = [];

  public getSmsCreditSummaries({ columns, data }) {
    const sum = ['Total'];

    // regions
    for (const region of this.regions) {
      let rowSum = 0;
      for (const d of data) {
        const credit = d.credits.find(p => p.region.id === region.id);
        if (credit) {
          rowSum += credit.credit;
        }
      }
      sum.push(rowSum.toString());
    }

    // wallet
    const totalBalance = Enumerable.from(data as any[])
      .selectMany(p => p.credits as any[])
      .groupBy(p => p.wallet.id)
      .select(p => p.first() as any)
      .sum(p => +p.wallet.balance);
    sum.push(`${data[0].credits[0].wallet.currencyCode} ${totalBalance.toFixed(4)}`);

    return sum;
  }

  public getSmsUsageSummaries({ columns, data }) {
    const sum = ['Total', '', '', '', ''];

    const totalMessageCount: number = data.reduce((s, d) => s + +d.messageCount, 0);
    sum.push(totalMessageCount.toString());

    const totalCost: number = data.reduce((s, d) => s + +d.cost, 0);
    sum.push(`${data[0].currencyCode} ${totalCost.toFixed(4)}`);

    return sum;
  }

  public getWhatsAppUsageSummaries({ columns, data }) {
    const sum = ['Total', ''];

    const totalSessionUsage = data.reduce((s, d) => s + +d.sessionCount, 0);
    sum.push(totalSessionUsage.toString());

    const totalTemplateUsage: number = data.reduce((s, d) => s + +d.templateCount, 0);
    sum.push(totalTemplateUsage.toString());

    const totalSessionCost: number = data.reduce((s, d) => s + +d.sessionCost, 0);
    sum.push(`${data[0].currencyCode} ${totalSessionCost.toFixed(4)}`);

    const totalTemplateCost: number = data.reduce((s, d) => s + +d.templateCost, 0);
    sum.push(`${data[0].currencyCode} ${totalTemplateCost.toFixed(4)}`);

    const totalCost: number = data.reduce((s, d) => s + +d.sessionCost + +d.templateCost, 0);
    sum.push(`${data[0].currencyCode} ${totalCost.toFixed(4)}`);

    return sum;
  }

  public mounted() {
    this.loadData();
    this.chartAutoResize();
  }

  // filter event
  public async onClickLastMonth() {
    const time = moment().local().add(-1, "M");
    this.dateRange = [
      time.startOf('month').toDate(),
      time.endOf('month').toDate(),
    ];

    await this.reloadDashboard();
  }

  public async onClickThisMonth() {
    this.dateRange = [moment().local().startOf('month').toDate(), new Date()];
    await this.reloadDashboard();
  }

  //
  private async loadData() {
    await Promise.all([
      this.reloadDashboard(),
      this.loadCustomers(),
      this.loadRegions(),
    ]);
  }

  // load dashboard
  private async loadDashboardSummary() {
    if (!this.customerId) {
      this.dashboardSummary = null;
      const { data } = await apiClient.customersDashboardsSummary(this.getFilter())
      this.dashboardSummary = data;
    }
  }

  private async loadCustomerDashboardItems() {
    if (this.customerId) {
      await Promise.all([
        this.loadCustomerDashboardSummary(),
        this.loadCustomerDashboard(),
      ]);
    }
  }

  private async loadCustomerDashboardSummary() {
    this.dashboardSummary = null;
    const { data } = await apiClient.customerDashboardsSummary(this.customerId, this.getFilter());
    this.dashboardSummary = data;
  }

  private async loadCustomerDashboard() {
    this.dashboards = [];
    const { data } = await apiClient.customersDashboardsApplications(this.customerId, this.getFilter());
    this.dashboards = data;
  }

  // load meta
  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }

  private async loadRegions() {
    const { data } = await apiClient.regions();
    this.regions = data;
  }

  //
  private async reloadDashboard() {
    this.isDashboardLoading = true;
    await Promise.all([
      this.loadDashboardSummary(),
      this.loadCustomerDashboardItems(),
    ]);
    this.isDashboardLoading = false;
  }

  // filters
  private getFilter() {
    const filter: any = {};

    if (this.dateRange && this.dateRange.length) {
      filter.from = this.dateRange[0];
      filter.to = this.dateRange[1];
    }

    return filter;
  }

  // other
  private chartAutoResize() {
    window.addEventListener('resize', () => {
      if (Array.isArray(this.$refs.charts)) {
        for (const chart of this.$refs.charts as any[]) {
          chart.chart.resize();
        }
      }
    });
  }

}
